import * as React from "react";
import classNames from "classnames";
import styles from "./Content.module.css";

interface ContentProps extends React.AllHTMLAttributes<HTMLElement> {
  className?: string;
  containerClassName?: string;
  stretch?: boolean;
  ref?: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
}

const Content: React.FC<ContentProps> = ({
  ref,
  className,
  containerClassName,
  stretch = false,
  children,
  ...rest
}) => {
  return (
    <div
      {...rest}
      ref={ref}
      className={classNames(
        styles.wrapper,
        { [styles.stretch]: stretch },
        className,
      )}
    >
      {stretch ? (
        <div className={classNames(styles.container, containerClassName)}>
          {children}
        </div>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export default Content;
